<template lang="pug">
  .PrologueUniVueComponentSelect(:class="{'PrologueUniVueComponentSelect--open': selectOpen, 'PrologueUniVueComponentSelect--disabled': data && data.options.length < 2}")
    .PrologueUniVueComponentSelect__content-wr
      .PrologueUniVueComponentSelect__content(v-if="data")
        select.PrologueUniVueComponentSelect__native(:name="data.name", :required="data.required", ref="selectNative")
          option(v-if="data.options", v-for="option in data.options", :value="option.value")
            | {{option.title}}

        .PrologueUniVueComponentSelect__top(v-on:click="selectOpenFn($event)")
          .PrologueUniVueComponentSelect__top-left
            .PrologueUniVueComponentSelect__top-left-title
              | {{selectedTxt}}
          .PrologueUniVueComponentSelect__top-right
            SvgIcon.PrologueUniVueComponentSelect__top-right-ico(name="arrow1" width="12" height="7")
        .PrologueUniVueComponentSelect__bottom
          .PrologueUniVueComponentSelect__bottom-items
            .PrologueUniVueComponentSelect__bottom-item(v-if="data.options", v-for="option in data.options", v-on:click="setCurrentSelect($event, option.id, option.value, option.title, data.name, option)")
              | {{option.title}}

</template>

<script>
  import '@/components/common/select/select.styl';

  import EventBus from '@/eventBus';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  export default {
    name: 'Select',

    props: ['data', 'idBlock', 'productId', 'count'],

    components: {
      SvgIcon
    },

    data() {
      return {
        //selectedId: '',
        //selectedValue: '',
        selectedTxt: '',
        selectOpen: false
      }
    },

    created() {
      EventBus.$on('closeSelect', () => {
        this.selectOpen = false;
      });

      this.setDefaultSelect();
    },

    methods: {

      setDefaultSelect() {
        //this.selectedId    = this.data.id || '';
        //this.selectedValue = this.data.value || '';
        this.selectedTxt = this.data.options[0].title || '';
      },

      setCurrentSelect(e, idSelect, valueSelect, txtSelect, nameSelect, option) {
        //this.selectedId    = idSelect;
        //this.selectedValue = valueSelect;
        //this.selectedTxt   = txtSelect;

        //this.selectOpen = false;

        this.selectOpen = false;

        this.selectedTxt = txtSelect;

        $(this.$refs.selectNative).find('option').each((i, el) => {
          if(valueSelect === $(el).val()) {
            $(this.$refs.selectNative).val(valueSelect);
          }
        });

        if(this.productId) {
          option.productId = this.productId;
        }

        if(this.count) {
          option.count = this.count;
        }

        this.$emit('setCurrentSelect', option);

        /*this.$store.commit('setPrologueUniVueComponentInfoBlockData', {
          idPage: this.$store.state.idActivePage || '',
          idBlock: this.idBlock,
          idElement: idSelect,
          nameElement: nameSelect,
          valueElement: valueSelect
        });*/

        //console.log('state', this.$store.state.PrologueUniVueComponentInfoBlockData);
      },

      selectOpenFn() {
        this.selectOpen = !this.selectOpen;
      }
    }
  }
</script>
